import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { contentDate, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import { useState } from 'react'
import { RequestProvider } from '../../../context/RequestContext'
import { AirconRepair } from '../../../components/index/service-category/aircon-service/AirconRepair'
import { Services } from '../../../components/index/service/Services'
import { BottomButtons } from '../../../components/index/service-category/aircon-service/BottomButtons'
import Link from 'next/link'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../../lib/service'
import { getWpHvacServices, getWpNewHvacServices, setWpHvacServices, setWpNewHvacServices } from '../../../service/wp-blogs-store'
import { AirconQuickLinks } from '../../../components/index/service-category/aircon-service/AirconQuickLinks'
import { buildAirconServiceGraph } from 'utils/aircon-page-schema'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-10-25'

export async function getStaticProps() {
    let lat = 1.3521
    let lng = 103.8198
    const { month, year } = contentDate(CONTENT_REVIEWED);
    const modifiedDate = reviewedIso(CONTENT_REVIEWED);
    const airconBlogs = blogsMaster['hvac-services'].blogArray;
    const wpPosts = getWpHvacServices().length > 0 ?  getWpHvacServices() : await getWpPostsByCategory(6, "hvac-services");
    setWpHvacServices(wpPosts)
    const wpNewPosts = getWpNewHvacServices().length > 0 ?  getWpNewHvacServices() : await getWpNewPostsByCategory(6, "hvac-services");
    setWpNewHvacServices(wpNewPosts)

    const allRequestCategorySettings = await getRequestJSON("Singapore")
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        airconBlogs,
        wpNewPosts,
        wpPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const countryName = "Singapore"
    const requestType = "Aircon Services"

    const [ requestForm, setRequestForm ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

    const maxRating = [1, 2, 3, 4, 5]

  return (
    <>
      <Head>
        <title>Aircon Installation Singapore | Supply & Install, HDB & Condo</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Aircon supply and installation in Singapore for HDB flats, condos and landed homes: which system you need, what drives the cost, how long it takes. Get a quote."/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-installation" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Aircon Installation Singapore | Supply & Install, HDB & Condo`}/>
        <meta property="og:description" content="Aircon supply and installation in Singapore for HDB flats, condos and landed homes: which system you need, what drives the cost, how long it takes. Get a quote." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-02T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon-installation.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon-installation.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-installation"/>
        <meta name="twitter:title" content={`Aircon Installation Singapore | Supply & Install, HDB & Condo`}/> 
        <meta name="twitter:description" content="Aircon supply and installation in Singapore for HDB flats, condos and landed homes: which system you need, what drives the cost, how long it takes. Get a quote."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-installation"/>
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(buildAirconServiceGraph({
            path: '/sg/aircon-servicing-singapore/aircon-installation',
            pageName: 'Aircon Installation Singapore | Supply & Install, HDB & Condo',
            description: 'Aircon supply and installation in Singapore for HDB flats, condos and landed homes: which system you need, what drives the cost, how long it takes. Get a quote.',
            serviceName: 'Aircon Installation Singapore',
            serviceType: 'Aircon Installation',
            image: 'https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon-installation.jpg',
            datePublished: '2025-01-02T07:30:46+00:00',
            modifiedDate,
            breadcrumbName: 'Aircon Installation',
          })) }}
        />
        </Head>
        <div>
            {/* Hero H1 lives in AirconRepair; the body heading below is an H2. This
                replaced AirconServiceRequestForm, which auto-opened the question
                wizard on page load. */}
            <RequestProvider>
                <section id="aircon-installation" className='relative'>
                    <AirconRepair
                        setRequestForm={setRequestForm}
                        setIsQuickBook={setIsQuickBook}
                        title="Aircon Installation Singapore"
                        problem="New aircon installation"
                        heroImage="blog/living/aircon-installation.jpg"
                        subtitle="Supply and installation for HDB flats, condos and landed homes. Tell us the rooms or the model you want and we will quote."
                        inputLabel="What do you need installed?"
                    />
                </section>
                {!requestForm &&
                    <BottomButtons countryName={countryName}/>
                }
                {requestForm &&
                    <Services
                        requestType={requestType}
                        requestCategorySettings={requestCategorySettings}
                        setRequestForm={setRequestForm}
                        isQuickBook={isQuickBook}
                        isCustomBook={false}
                        asSheet
                    />
                }
            </RequestProvider>
            <div className='max-w-5xl mx-auto py-8 px-4 leading-relaxed text-gray-700 space-y-8'>
                <section className='space-y-3'>
                    <h2 className='text-2xl md:text-3xl font-bold text-gray-900'>Aircon Supply and Installation in Singapore</h2>
                    <p>
                        StringsSG supplies and installs aircons for HDB flats, condominiums and landed homes, from a single wall-mounted unit to
                        a System 4 multi-split. Tell us the rooms you want to cool, or the brand and model you already have in mind, and we quote
                        the unit and the installation together. If you are replacing an old aircon, mention it so the quote covers taking the old
                        one down.
                    </p>
                    <div className='relative h-72 md:h-96'>
                        <Image className='rounded-lg'
                            src={s3Static + "blog/living/aircon-installation.jpg"}
                            fill
                            sizes="(max-width: 768px) 100vw, 960px"
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Technician installing a wall-mounted aircon fan coil unit in a Singapore home'
                        />
                    </div>
                </section>

                <section className='space-y-3'>
                    <h2 className='text-xl md:text-2xl font-bold text-gray-900'>System 1, 2, 3 or 4: Which Do You Need?</h2>
                    <p>
                        In Singapore a &quot;system&quot; aircon means one outdoor condenser running several indoor fan coils. System 1 is one
                        condenser with one fan coil; System 4 is one condenser with four. Most homes count one fan coil per room to be cooled, so a
                        flat cooling the living room and three bedrooms needs a System 4, or a System 3 plus a separate System 1.
                    </p>
                    <ul className='list-disc pl-5 space-y-1'>
                        <li><strong>Multi-split (System 2 to 4):</strong> one condenser on the ledge, less outdoor space used, usually cheaper than separate units. If the condenser fails, every room on it stops.</li>
                        <li><strong>Separate System 1 units:</strong> each room independent, so one fault does not take out the others, but you need ledge space for more condensers.</li>
                    </ul>
                </section>

                <section className='space-y-3'>
                    <h2 className='text-xl md:text-2xl font-bold text-gray-900'>Choosing the Unit</h2>
                    <ul className='list-disc pl-5 space-y-2'>
                        <li><strong>Cooling capacity.</strong> As a rough guide, a common bedroom takes a 9,000 BTU fan coil, a master bedroom 12,000 BTU and a living room 18,000 to 24,000 BTU, depending on size and how much sun it gets. The installer should size each room before quoting.</li>
                        <li><strong>Energy ticks.</strong> Aircons sold in Singapore carry the NEA energy label, rated in ticks; more ticks means lower running costs, which matters more than the purchase price over the unit&apos;s life.</li>
                        <li><strong>Inverter or not.</strong> Inverter units adjust compressor speed instead of switching on and off, which saves power in rooms cooled for long hours. See <Link href='/sg/aircon-servicing-singapore/inverter-vs-non-inverter-aircon-which-is-a-better-choice' prefetch={false} className='text-orange-600 underline'>inverter vs non-inverter aircon</Link>.</li>
                        <li><strong>Brand.</strong> Daikin, Mitsubishi, Panasonic, LG and Samsung are all common here; parts availability and the servicing you can get matter more than the badge. Compare them in <Link href='/sg/aircon-servicing-singapore/compare-top-air-conditioner-brands-in-singapore' prefetch={false} className='text-orange-600 underline'>top aircon brands in Singapore</Link>.</li>
                    </ul>
                </section>

                <section className='space-y-3'>
                    <h2 className='text-xl md:text-2xl font-bold text-gray-900'>What Affects Aircon Installation Cost</h2>
                    <p>Installation is quoted per job because these change the price far more than the brand does:</p>
                    <ul className='list-disc pl-5 space-y-1'>
                        <li>the system size and the number of fan coils</li>
                        <li>the model and its tick rating</li>
                        <li>how far the copper piping runs from each fan coil to the condenser, and how much trunking is needed</li>
                        <li>taking down and removing an old unit</li>
                        <li>electrical work, such as a new isolator or power point</li>
                        <li>drilling through walls, and where the condenser goes: a ledge, or a bracket that needs work at height</li>
                    </ul>
                </section>

                <section className='space-y-3'>
                    <h2 className='text-xl md:text-2xl font-bold text-gray-900'>HDB, Condo and Landed Homes</h2>
                    <ul className='list-disc pl-5 space-y-2'>
                        <li><strong>HDB flats:</strong> the outdoor condenser goes on the flat&apos;s designated aircon ledge, and the work has to follow HDB&apos;s renovation guidelines for air-conditioner installation.</li>
                        <li><strong>Condominiums:</strong> check with your management (MCST) before booking; many condos set where condensers may go and the hours renovation work is allowed.</li>
                        <li><strong>Landed homes:</strong> more freedom on condenser placement, but keep units clear of neighbours&apos; windows and leave space around them for airflow and servicing.</li>
                    </ul>
                </section>

                <section className='space-y-3'>
                    <h2 className='text-xl md:text-2xl font-bold text-gray-900'>How Long Installation Takes, and How to Prepare</h2>
                    <p>
                        A single wall unit is typically installed within a few hours; a System 4 with new piping often takes most of a day. Clear
                        the wall area, cover furniture near the fan coil positions, and expect some drilling dust. Before the technicians leave, test
                        cooling, swing and every remote function in each room.
                    </p>
                    <p>
                        Once it is running, keep it running well: a new aircon still needs regular servicing. See{' '}
                        <Link href='/sg/aircon-servicing-singapore/how-often-should-i-service-aircon-for-best-performance' prefetch={false} className='text-orange-600 underline'>how often to service your aircon</Link>{' '}
                        and our <Link href='/sg/aircon-servicing-singapore/annual-package' prefetch={false} className='text-orange-600 underline'>annual servicing packages</Link>.
                    </p>
                </section>
            </div>
            <BlogsList blogs={airconBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
            {/* <AirconQuickLinks/> */}
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
